import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_RICH_PLACEMENT_MULTI_ANCHOR } from './api/query'
import { RichPlacementMultiAnchor, UseGetRichPlacementMultiAnchor } from './types'

import type {
  GetRichPlacementMultiAnchorQuery,
  GetRichPlacementMultiAnchorQueryVariables,
} from 'gql/graphql'

export const useGetRichPlacementMultiAnchor = (): UseGetRichPlacementMultiAnchor => {
  const { workspaceId } = useWorkspaceParam()
  const ability = useAbility()

  const { data, isLoading } = useQuery<
    GetRichPlacementMultiAnchorQueryVariables,
    GetRichPlacementMultiAnchorQuery,
    RichPlacementMultiAnchor
  >({
    options: {
      select: ({
        workspaceRichPlacementMultianchorConfiguration,
      }: GetRichPlacementMultiAnchorQuery): RichPlacementMultiAnchor =>
        fromDTO(workspaceRichPlacementMultianchorConfiguration),
    },
    query: GET_RICH_PLACEMENT_MULTI_ANCHOR,
    variables: {
      canReadFrequencyCapping: ability.can('read', 'GlobalSetupField-frequencyCapping'),
      workspaceId,
    },
  })

  return { isLoading, multiAnchor: data }
}
